<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Booster</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Booster Type</label>
          <select class="form-control" [(ngModel)]="boosterType">
            @for (key of $any(UserBoosterType) | keyvalue; track key.key) {
              @if (!isNaN(+key.value) && +key.value !== 0) {
                <option [ngValue]="+key.value">{{ key.key }}</option>
              }
            }
          </select>
        </div>
        <div class="form-group mb-3">
          <label>Multiplier</label>
          <input class="form-control" [(ngModel)]="multiplier" placeholder="2" type="number">
        </div>
        <div class="form-group">
          <label>Duration (seconds)</label>
          <input class="form-control" [(ngModel)]="duration" placeholder="3600" type="number">
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
